import {Component, Input, OnInit} from '@angular/core';
import {CerfComment} from '../../interfaces/CerfComment';

@Component({
  selector: 'app-cerf-comments',
  templateUrl: './cerf-comments.component.html',
  styleUrls: ['./cerf-comments.component.scss']
})
export class CerfCommentsComponent implements OnInit {

  public currentCommentText = '';
  public loading = false;
  @Input()
  public saveComment: (text: string) => Promise<any>;
  @Input()
  public comments: CerfComment[] = [];

  constructor() { }

  ngOnInit() {
  }

  public get canComment() {
    return this.currentCommentText.replace(/\s+/, '').length !== 0;
  }

  async addComment() {
    if (!this.canComment) return;
    try {
      this.loading = true;
      await this.saveComment(this.currentCommentText);
      this.loading = false;
      this.currentCommentText = '';
    } catch (e) {
      this.loading = false;
      alert('Failed to make comment')
    }
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/cerf/components/cerf-comments/cerf-comments.component.ts